export default {
  data () {
    return {
      isActive: false
    }
  },
  activated () {
    this.isActive = true
  },
  deactivated () {
    this.isActive = false
  }
}



// WEBPACK FOOTER //
// ./src/mixins/isActive.js